const systemPointId = {
	system_point: {
		title: "System Point",
		subtitle: "Aturan & Reward system point",
		table: {
			title: "Data Reward",
			empty_state: {
				title: "Tidak ada data reward",
				description: "Silakan tambahkan reward baru.",
			},
			columns: {
				redeem_points: "Redeem Points",
				reward_type: "Jenis Reward",
				reward: "Reward",
				max_reward: "Maksimal Reward",
				action: "Action",
			},
			types: {
				percent: "Diskon (%)",
				amount: "Nominal (Rp)",
			},
			points_unit: "points",
			delete_confirm: "Apakah Anda yakin ingin menghapus reward ini?",
			delete_success: "Reward berhasil dihapus",
			delete_error: "Gagal menghapus reward",
		},
		rule_modal: {
			trigger: "Atur Loyalty Program",
			title: "Loyalty Program",
			description:
				"Pelanggan akan mendapatkan points tertentu dari total pembelanjaan pada setiap transaksi.",
			active: "Active",
			inactive: "Inactive",
			fields: {
				amount: "Pembelanjaan",
				amount_placeholder: "Rp 0",
				points: "Points yang didapatkan",
				points_placeholder: "0 points",
				is_multiple: "Berlaku kelipatannya?",
			},
			cancel: "Batal",
			save: "Simpan",
		},
		reward_modal: {
			trigger: "Tambah Reward",
			title: "Tambah Reward",
			select_label: "Pilih reward penukaran points",
			types: {
				discount: {
					title: "Diskon (%)",
					description:
						"Pelanggan akan mendapatkan Diskon % dari total pembelanjaan pada penukaran sejumlah points tertentu.",
				},
				amount: {
					title: "Potongan (Rp)",
					description:
						"Pelanggan akan mendapatkan Potongan harga tertentu pada penukaran sejumlah points tertentu.",
				},
			},
			fields: {
				redeem_points: "Jumlah points yang ditukar",
				reward_discount: "Jumlah diskon yang didapat",
				max_discount: "Maksimal diskon",
				reward_amount: "Jumlah potongan yang didapat",
			},
			cancel: "Batal",
			save: "Simpan",
		},
	},
};

export default systemPointId;
